/**
 * The localStorage prefix of "Keep the edited script" (#138), one key per
 * mailbox. A leaf so session teardown can purge the keys without importing
 * the feature (#577).
 */
export const KEEP_EDITED_PREFIX = 'ols-mail.filters.keep-edited:';
